/**
 * Maps Next.js locale codes to Contentful locale codes
 *
 * Next.js Locales:
 * - 'nl-NL': Dutch (Netherlands) - for colora.nl domain
 * - 'nl': Dutch (Belgium) - for colora.be domain
 * - 'fr': French (Belgium) - for colora.be domain
 *
 * Contentful Locales:
 * - 'nl-NL': Dutch (Netherlands)
 * - 'nl-BE': Dutch (Belgium)
 * - 'fr-BE': French (Belgium)
 */

import {
  mapContentfulToNextLocale,
  mapNextLocaleToContentfulLocaleMarket,
  mapNextToContentfulLocaleMarket,
  mapNextToContentfulMarket,
} from '@boss/utils';

export {
  mapContentfulToNextLocale,
  mapNextLocaleToContentfulLocaleMarket,
  mapNextToContentfulLocaleMarket,
  mapNextToContentfulMarket,
};
